<script setup>
import { ToastHost } from '@drama/ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <RouterView class="app-desktop" />
  <main class="app-viewport-warning">
    <section>
      <span>{{ t('visualGameStudio.seal') }}</span>
      <h1>{{ t('visualGameStudio.viewport.title') }}</h1>
      <p>{{ t('visualGameStudio.viewport.body') }}</p>
    </section>
  </main>
  <ToastHost />
</template>

<style scoped>
.app-viewport-warning {
  min-height: 100vh;
  display: none;
  place-items: center;
  padding: var(--drama-space-xl);
  background: var(--drama-color-bg);
}

.app-viewport-warning section {
  display: grid;
  gap: var(--drama-space-md);
  width: min(420px, 100%);
  padding: var(--drama-space-xl);
  border: 1px solid var(--drama-color-border);
  border-radius: var(--drama-radius-md);
  background: var(--drama-color-surface);
  color: var(--drama-color-text);
  text-align: center;
}

.app-viewport-warning span {
  display: grid;
  place-items: center;
  justify-self: center;
  width: 48px;
  height: 48px;
  border: 1px solid var(--vgs-line-gold);
  border-radius: var(--drama-radius-md);
  color: var(--drama-color-primary);
  font-family: var(--drama-font-family-heading);
  font-weight: var(--drama-font-weight-medium);
}

.app-viewport-warning h1,
.app-viewport-warning p {
  margin: 0;
}

.app-viewport-warning h1 {
  font-size: var(--drama-font-size-lg);
  font-weight: var(--drama-font-weight-medium);
}

.app-viewport-warning p {
  color: var(--drama-color-text-muted);
  line-height: 1.5;
}

@media (max-width: 1023px) {
  .app-desktop {
    display: none;
  }

  .app-viewport-warning {
    display: grid;
  }
}
</style>
